import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Order } from '../../types/order';
import { toast } from 'react-toastify';

interface ModalOrderVastProps {
    isOpen: boolean;
    toggle: () => void;
    order: Order;
}

const ModalOrderVast: React.FC<ModalOrderVastProps> = ({ isOpen, toggle, order }) => {
    const adManagerVastTagUrl = `${process.env.REACT_APP_FASTLANE_API_URL}/vast?c=${order?.campaignId}&o=${order.id}&ui=%%PATTERN:iu%%&url=%%REFERRER_URL_ESC%%&description_url=%%DESCRIPTION_URL_ESC%%&width=%%WIDTH%%&height=%%HEIGHT%%&correlator=%%TAG_PARAM:correlator%%&ct=%%CLICK_URL_ESC%%&pv=%%PREVIEW_MODE%%&output=vast_4`;
    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
            <ModalHeader toggle={toggle} className="bg-light p-3">
                TAG VAST
            </ModalHeader>
            <ModalBody>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col">
                            <p>
                                Insira a TAG VAST abaixo no creative do seu Ad Manager.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="input-group"
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    navigator.clipboard.writeText(adManagerVastTagUrl);
                                    toast.success('TAG VAST copiada para a área de transferência!');
                                }}
                            >
                                <input
                                    type="text"
                                    className="form-control"
                                    value={adManagerVastTagUrl}
                                    readOnly
                                />
                                <span className="input-group-text"><i className="ri-clipboard-line"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default ModalOrderVast;